import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 flex min-w-0 flex-col gap-2.5 border-0 p-0"
}
const _hoisted_2 = { class: "sr-only" }
const _hoisted_3 = ["aria-label"]

import { useId } from 'vue'


export default {
  __name: 'SelectionGroup',
  props: {
  label: { type: String, required: true },
  mode: { type: String, default: 'radio' }
},
  setup(__props) {



const groupName = `selection-${useId()}`

return (_ctx, _cache) => {
  return (__props.mode === 'radio')
    ? (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
        _createElementVNode("legend", _hoisted_2, _toDisplayString(__props.label), 1),
        _renderSlot(_ctx.$slots, "default", { groupName: groupName })
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        role: "group",
        "aria-label": __props.label,
        class: "flex flex-col gap-2.5"
      }, [
        _renderSlot(_ctx.$slots, "default", { groupName: groupName })
      ], 8, _hoisted_3))
}
}

}